<template>
    <div class="section-news" >
        <div class="blogLink-title">
            <h2>ReCheck</h2>
        </div>
        <div class="blogLink-description">
            <p @click="tapUrl">{{ $t('reCheck.newsItemContent') }}</p>
        </div>
        <div class="blogLink-button">
            <span @click="tipNews">{{ $t('reCheck.newsButton') }}</span>
        </div>
    </div>

    
</template>

<script>
export default {
    data() {
        return {
            
        }
    },
    created() {

    },
    mounted() {

    },

    methods: {
        tapUrl(){
            window.open('https://mp.weixin.qq.com/s/KVXQmVTzDxSAnksqngdsAw','_blank')
        },
        tipNews() {
            this.$router.push({
                path: '/news'
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.section-news {
    color: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: 60px auto;
    padding: 40px;
    border-radius: 8px;
    box-sizing: border-box;
    background-color: #30343a;
    background-repeat: repeat;
    background-attachment: fixed;
    background-position: center;
    background-size: 735px 240px;
    background-image: url("../../../assets/images/blog_featured.png");
}

.blogLink-description {
    width: 60%;

    >p {
        color: #fff;
        font-size: 16px;
        line-height: 24px;
    }
}

.blogLink-button {
    span {
        display: inline-block;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        padding: 6px 20px;
        background: #ffffff;
        border-radius: 18px;
        color: #353f4e;
    }

    span:hover {
        cursor: pointer;
    }

}

.blogLink-description{
    >p:hover{
        cursor: pointer;
        color: #4e6ef2;
    }
}

@media screen and (max-width: 600px) {
    .section-news {
        display: block;
    }
}
</style>